const deliveryChannels = {};

deliveryChannels.APPLICATION = 'APPLICATION';
deliveryChannels.EMAIL = 'EMAIL';
deliveryChannels.FACEBOOK = 'FACEBOOK';
deliveryChannels.TWITTER = 'TWITTER';
deliveryChannels.LINKED_IN = 'LINKED_IN';

export default deliveryChannels;